import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import Layout from './components/Layout';
import 'semantic-ui-css/semantic.min.css';
import './index.css';
import { UserProvider } from './context/User';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { StatusProvider } from './context/Status';
import { ThemeProvider } from './context/Theme';
import './i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <StatusProvider>
        <UserProvider>
          <BrowserRouter>
            <Layout>
              <App />
            </Layout>
            <ToastContainer />
          </BrowserRouter>
        </UserProvider>
      </StatusProvider>
    </ThemeProvider>
  </React.StrictMode>
);
